import {Component, ComponentFactoryResolver, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {DataEntity, Options, Property} from '@Interfaces/index';
import {CustomDirective} from '@Components/util/custom.directive';
import {DetailModificationComponent} from '@Components/presupuesto/detail-modification/detail-modification.component';
import {ICustomComponent} from '@Components/util/ICustomComponent';
import { RelateAssetsComponent } from '@Components/movimiento-bienes/relate-assets/relate-assets.component';
import { DepreciationHistoryComponent } from '@pages/movimiento-bienes/depreciation-history/depreciation-history.component';
import { FormAssetsComponent } from '@pages/movimiento-bienes/form-assets/form-assets.component';
import { CxpAssetsFormComponent } from '@pages/movimiento-bienes/cxp-assets-form/cxp-assets-form.component';

@Component({
  selector: 'app-custom-component',
  templateUrl: './custom-component.component.html',
  styleUrls: ['./custom-component.component.scss']
})
export class CustomComponentComponent implements OnInit {

  @Input() field: Property;
  @Input() dataEntity: DataEntity;
  @Input() group: string;
  @Input() item: any;
  @Output() reloadData = new EventEmitter<void>();

  @ViewChild(CustomDirective, {static: true}) adHost!: CustomDirective;


  constructor(private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit(): void {
    this.loadComponent();
  }

  private getComponent()
  {
    switch (this.field.options[Options.CUSTOM_COMPONENT]){
      case 'DetailModificationComponent':
        return DetailModificationComponent;
      case 'RelateAssetComponent':
        return RelateAssetsComponent;
      case 'DepreciationHistoryComponent':
        return DepreciationHistoryComponent;
      case 'FormAssetsComponent':
        return FormAssetsComponent;
      case 'CxpAssetsFormComponent':
        return CxpAssetsFormComponent;
      default:
            return null;
    }
  }

  loadComponent() {

    const component = this.getComponent();

    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component as any);

    const viewContainerRef = this.adHost.viewContainerRef;
    viewContainerRef.clear();
    const componentRef = viewContainerRef.createComponent<ICustomComponent>(componentFactory as any);
    componentRef.instance.setConfig(this.field, this.dataEntity, this.group, this.item);
    componentRef.instance.reloadData?.subscribe((data: any) => {
      componentRef.instance.setConfig(this.field, this.dataEntity, this.group, this.item);
      this.reloadData.emit();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['item']) {
      this.loadComponent();
    }
  }

}
